export default "__VITE_ASSET__Nanf7KTy__"